import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import type { CatalogResponse, QueryResponse, WidgetSpec } from '../../types/analytics';

export const useCatalog = (enabled = true) =>
  useQuery({
    queryKey: ['analytics', 'catalog'],
    queryFn: async () => (await apiClient.get<CatalogResponse>('/analytics/catalog')).data,
    enabled,
    staleTime: 30 * 60 * 1000,
  });

export const useWidgetData = (spec: WidgetSpec, enabled = true) =>
  useQuery({
    queryKey: ['analytics', 'query', spec],
    queryFn: async () =>
      (await apiClient.post<QueryResponse>('/analytics/query', { spec })).data,
    enabled,
    staleTime: 60 * 1000,
  });
